import { cn } from "@omni/utils/styles";
import { useEffect } from "react";

import { Modal } from "@/components/General/Modal/modal";
import {
    CTAActions,
    ProductCallToAction
} from "@/redux/modules/api/data/cart/@types/cart.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

import List from "./partials/list";

type Props = {
    title: string;
    description: string;
    confirmButtonText: string;
    closable?: boolean;
    onSubmit: () => void;
    cta: ProductCallToAction;
    activatedAction?: CTAActions;
};

const Selectable = ({
    title,
    description,
    confirmButtonText,
    closable = false,
    onSubmit,
    cta,
    activatedAction
}: Props) => {
    const {
        closeDialog,
        modalState,
        isLoading,
        isExtendedActive,
        setExtendedActive,
        activeType
    } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setExtendedActive(
            !!activatedAction?.isExtended &&
                activeType?.type === activatedAction.type
        );
    }, [activatedAction, activeType]);

    const setOpen = (state: boolean) => {
        if (!state) {
            closeDialog();
        }
    };

    return (
        <Modal
            title={
                <h1 className="text-danger">
                    <i className="las la-exclamation-triangle mr-2" />
                    {title}
                </h1>
            }
            autoFocus={false}
            centered={false}
            size={"sm"}
            open={modalState}
            closable={closable}
            setOpen={setOpen}
            confirmButtonText={confirmButtonText}
            onConfirm={onSubmit}
            isLoading={isLoading}
            withFooter={!isExtendedActive}
        >
            {description && (
                <p className={cn("font-weight-bold")}>{description}</p>
            )}
            {!isExtendedActive && (
                <List
                    cta={cta}
                    activatedAction={activatedAction}
                />
            )}
            {isExtendedActive &&
                activatedAction?.action?.(cta.product, activatedAction)}
        </Modal>
    );
};

export { Selectable };
